import { DEV_TOKEN_PREFIX, devIdentitySchema, } from '@britania/teams-kit-core';
const STORAGE_KEY = 'teams-kit.dev-identity';
/** Mesmo formato do backend: `dev.` + JSON em base64url, sem assinatura. */
export function encodeDevToken(identity) {
    const bytes = new TextEncoder().encode(JSON.stringify(identity));
    const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');
    const base64url = btoa(binary)
        .replaceAll('+', '-')
        .replaceAll('/', '_')
        .replace(/=+$/, '');
    return `${DEV_TOKEN_PREFIX}${base64url}`;
}
/** Quem entrou da última vez neste navegador, para não pedir de novo. */
export function readDevUser() {
    try {
        const parsed = devIdentitySchema.safeParse(JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'null'));
        return parsed.success && parsed.data.kind === 'user' ? parsed.data : null;
    }
    catch {
        return null;
    }
}
export function saveDevUser(user) {
    try {
        if (user === null) {
            localStorage.removeItem(STORAGE_KEY);
        }
        else {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
        }
    }
    catch {
        // Sem armazenamento, a pessoa entra de novo ao recarregar.
    }
}
//# sourceMappingURL=dev-identity.js.map